/* eslint */
/* global videojs */

import "../jQueryPlugins/makeSlider";
import $ from "jquery";

export default class AudioComponent {

    /** @type HTMLElement */
    _node = null;

    _player = null;

    onPlay = () => {};

    /**
     * AudioComponent instance, one instance should be created by displayed player on the page
     * @param {HTMLElement} uiNode
     * @param {HTMLAudioElement} audioNode
     */
    constructor(uiNode, audioNode = null) {

        this._node = uiNode;

        this._player = audioNode || videojs($(this._node).find("audio").attr("id"));
        this._onClickPlay = this._onClickPlay.bind(this);
        this._onClickVolumeBtn = this._onClickVolumeBtn.bind(this);
        this._onSeek = this._onSeek.bind(this);
        this._onUpdateVolume = this._onUpdateVolume.bind(this);

        this._state = (() => {

            let render = this._render.bind(this);

            let canPlay = false;
            let numberOfTimeThePlayButtonHasBeenUsed = 0;
            let paused = true;
            let duration = 0;
            let currentTime = 0;
            let volume = 0;
            let muted = false;
            let seeking = false;
            let ended = false;
            return {
                set canPlay(newState) {
                    canPlay = newState;
                    render();
                },
                get canPlay() {
                    return canPlay;
                },

                set numberOfTimeThePlayButtonHasBeenUsed(newState) {
                    numberOfTimeThePlayButtonHasBeenUsed = newState;
                },

                get numberOfTimeThePlayButtonHasBeenUsed() {
                    return numberOfTimeThePlayButtonHasBeenUsed;
                },

                set paused(newState) {
                    paused = newState;
                    render();
                },
                get paused() {
                    return paused;
                },

                set duration(newState) {
                    duration = newState;
                    render();
                },
                get duration() {
                    return duration;
                },

                set currentTime(newState) {
                    currentTime = newState;
                    render();
                },
                get currentTime() {
                    return currentTime;
                },

                set volume(newState) {
                    volume = newState;
                    render();
                },
                get volume() {
                    return volume;
                },

                set muted(newState) {
                    muted = newState;
                    render();
                },
                get muted() {
                    return muted;
                },

                set seeking(newState) {
                    seeking = newState;
                    render();
                },
                get seeking() {
                    return seeking;
                },

                set ended(newState) {
                    ended = newState;
                    render();
                },
                get ended() {
                    return ended;
                },
            };
        })();

        this._initPlayer();

        this._initUI();

        this._render();
        this._registerAudioEvents();
    }

    play() {
        this.onPlay();
        this._state.paused = false;
        this._state.ended = false;
        this._player.play();
    }

    pause() {
        this._state.paused = true;
        this._player.pause();
    }

    /**
     * attach event listener to the player (dom) instance
     * @private
     */
    _initPlayer() {

        const audioPlayer = this._player;
        const staticBaseUrl = window.STATIC_LPCDN_BASE_URL;

        audioPlayer.on("loadedmetadata", () => {
            this._state.duration = audioPlayer.duration();
            this._state.volume = audioPlayer.volume() * 100;
        });

        audioPlayer.on("timeupdate", () => {
            this._state.currentTime = audioPlayer.currentTime();
        });

        audioPlayer.on("durationchange", () => {
            this._state.duration = audioPlayer.duration();
        });

        audioPlayer.on("canplay", () => {
            this._state.canPlay = true;
        });

        audioPlayer.on("ended", () => {
            this._state.paused = true;
            this._state.ended = true;
        });

        audioPlayer.on("playing", () => {
            this.initMediaSession(staticBaseUrl);

        });



        audioPlayer.on("error", (e) => {
            this._state.canPlay = false;
            this._state.paused = true;
            this._state.duration = 0;
            this._state.currentTime = 0;
            this._state.volume = 0;
            this._state.muted = true;
            this._state.seeking = true;
            this._state.ended = false;
            console.error("%o", e);
        });

        this._player.src(
            this._node.getAttribute("data-src")
        );
        this._player.load();
    }

    initMediaSession(staticBaseUrl) {
        if ("mediaSession" in navigator) {
            navigator.mediaSession.metadata = new MediaMetadata({
                artist: "La Presse",
                artwork: [
                    {src: staticBaseUrl + "/mobile/img/logo-lp-2x.png", sizes: "120x120", type: "image/png"},
                ],
            });

            navigator.mediaSession.setActionHandler("play", () => {
                this.play();
            });

            navigator.mediaSession.setActionHandler("pause", () => {
                this.pause();
            });

            navigator.mediaSession.setActionHandler("previoustrack", () => {
                this._player.currentTime(0);
            });

            navigator.mediaSession.setActionHandler("stop", () => {
                this._player.pause().then(() => {
                    this._player.currentTime(0);
                });
            });
        }
    }

    /**
     * initialise player UI
     * @private
     */
    _initUI() {

        const $wrapper = $(this._node);
        const $volumeCtrl = $wrapper.find(".volumeCtrl");
        const $timeProgress = $wrapper.find(".currentTimeProgress");
        const $volumeProgress = $volumeCtrl.find(".volumeProgress");

        $wrapper.find(".playCtrl").on("click", this._onClickPlay);
        $volumeCtrl.find("button").on("click", this._onClickVolumeBtn);


        $timeProgress.makeSlider( {
            onStartDrag: this._onStartDragTimeSlider.bind(this),
            onSeek: this._onSeek.bind(this),
            onDragEnd: this._onDragEndTimeSlider.bind(this)
        } );

        $volumeProgress.makeSlider( {
            onSeek: this._onUpdateVolume.bind(this),
        } );
    }

    _onClickPlay() {
        // if (this._state.canPlay) {
        if (!this._state.paused)
            this.pause(false);
        else
            this.play();
        // }
    }

    _onClickVolumeBtn() {
        this._state.muted = !this._state.muted;
        this._player.muted(this._state.muted);
        !this._state.muted && this._player.volume(this._state.volume / 100);
    }

    _onUpdateVolume(percent) {
        this._state.volume = Math.min(100, Math.max(0, percent));
        this._player.volume(this._state.volume / 100);
    }

    _onStartDragTimeSlider() {
        this._state.seeking = true;
        // not calling this.pause() in order to keep this._state.paused untouched
        this._player.pause();
    }

    _onDragEndTimeSlider() {
        this._state.seeking = false;
        if (!this._state.paused) {
            this.play();
        }
    }

    _onSeek(percent) {
        const newTime = this._state.duration * (percent / 100);
        this._state.currentTime = newTime;
        this._player.currentTime(newTime);
    }

    _render() {
        const $wrapper = $(this._node);

        if (this._state.canPlay)
            $wrapper.addClass("canplay");
        else
            $wrapper.removeClass("canplay");

        if (this._state.paused)
            $wrapper.addClass("paused");
        else
            $wrapper.removeClass("paused");

        $wrapper.find(".duration").html(this._formatTime(this._state.duration));

        $wrapper.find(".currentTime").html(this._formatTime(this._state.currentTime));
        $wrapper.find(".currentTimeProgress .bar").css("width", (this._state.currentTime / this._state.duration * 100) + "%");

        if (!this._state.muted) {
            $wrapper.find(".volumeProgress .progress_bar").css("width", (this._state.volume) + "%");
        } else {
            $wrapper.find(".volumeProgress .progress_bar").css("width", 0 + "%");
        }

        if (0 === this._state.volume || this._state.muted) {
            $wrapper.find(".volumeCtrl .volume").addClass("mute");
            $wrapper.find(".volumeCtrl .volume").removeClass("sound");
        } else {
            $wrapper.find(".volumeCtrl .volume").removeClass("mute");
            $wrapper.find(".volumeCtrl .volume").addClass("sound");
        }

        if (this._state.seeking)
            $wrapper.addClass("seeking");
        else
            $wrapper.removeClass("seeking");

        if (this._state.ended)
            $wrapper.addClass("ended");
        else
            $wrapper.removeClass("ended");

    }

    hasAutoplayed() {
        return false;
    }

    muted() {
        return this._state.muted;
    }

    _registerAudioEvents() {
        this._player.on("play", () => {
            this._state.numberOfTimeThePlayButtonHasBeenUsed = this._state.numberOfTimeThePlayButtonHasBeenUsed + 1;
        });

        this._player.one("loadedmetadata", this._generateEventHandler("audioReady"));
        this._player.one("play", this._generateEventHandler("audioStarted"));
        this._player.on("play", this._generateEventHandler("audioUnpaused", () => {}, this._hasBeenPlayedAtLeastOneTimeAlready));
        this._player.on("pause", this._generateEventHandler("audioPaused"));
        this._player.on("timeupdate", this._generateEventHandler("audioTimeupdate"));
    }

    _hasBeenPlayedAtLeastOneTimeAlready() {
        return this._state.numberOfTimeThePlayButtonHasBeenUsed > 1;
    }

    /**
     * this event handler generator has been implented to be able to unit test handlers
     *
     * @param {string} eventName - name of the event the returned handler could trigger
     * @param {Function} eventCallback
     * @param {Function} condition - should return true or false
     */
    _generateEventHandler(eventName,  eventCallback = () => {}, condition = null) {
        return () => {
            let isConditionValid = typeof condition === "function" ? condition.call(this) : true;
            if (isConditionValid) {
                this._dispatchEvent(this._generateEvent(eventName));
                eventCallback();
            }

        };
    }

    _generateEvent(eventName) {
        return new CustomEvent(eventName, { bubbles: true, detail : {targetAudioCmp: this, targetAudioPlayer: this._player} });
    }

    _dispatchEvent(e) {
        const win = this._node.ownerDocument.defaultView || this._node.parentWindow;
        win && win.dispatchEvent(e);
    }

    _formatTime(seconds) {
        if ("number" !== typeof seconds || isNaN(seconds)) {
            return "0:00";
        }

        const minutes = Math.floor(seconds / 60);
        seconds = Math.floor(seconds % 60);
        seconds = (seconds >= 10) ? seconds : "0" + seconds;
        return minutes + ":" + seconds;
    }
}
